import { Close } from "@radix-ui/react-dialog";
import { DismissIcon } from "../../../materials/icons/dismiss-icon/DismissIcon";
import { IconButton } from "../../icon-button/IconButton.Parts";
import { Wrapper } from "./ModalClose.Parts";

export const ModalClose = () => (
  <Wrapper>
    <Close asChild>
      <IconButton>
        <DismissIcon />
      </IconButton>
    </Close>
  </Wrapper>
);
